import { store } from "../../../../../stateManager";
import { pushFormActionStack, redoComponentDropToFormJson, transferUndoRedoElementReference, undoDropElement, removeElement, pasteCopiedElemenet } from "../../../../../stateManager/store/formCreation_v2/actions";
import {
  CREATE_FORM_JSON,
  TRANSFER_ELEMENT_REFERENCE,
  PASTE_COPIED_ELEMENT,
  SAVE_FORM_JSON,
  UPDATE_PARENT_FIELDS
} from "../../../../../stateManager/store/formCreation_v2/types";
import { getRandomId } from "../../../../../utils/random-id";
import { addAssetInstancesToForm, getDefaultValues } from "../helpers";
import { ItemTypes } from "../types/ItemTypes";
import { myUndoStack, myRedoStack } from "../stack/Stack";
import { getDefaultValuesv3 } from "./formsv3/getDefaultValuesv3";
import { logger } from "../../../../../constant/winston";
import { wizardContentInitialState } from "./wizardHelpers";

export const onDrop = (
  dropTarget: { id: string },
  droppedItem: {
    type: ItemTypes,
    json: any,
  },
  deviceType: string,
  isCoreV3?: boolean
) => {
  const { json } = droppedItem;

  if (droppedItem.type === ItemTypes.TEMPLATE) {
    try {
      const randomString = getRandomId();
      const sendJson = require(`../template/assets/templates${json}`)
      const deepClone = (obj: any) => {
        return JSON.parse(JSON.stringify(obj));
      };

      let clonedJson = deepClone(sendJson);
      let rootId = clonedJson.componentOrder[0] + randomString;
      const modifiedData: any = modifyJson(clonedJson.components, randomString);
      if (dropTarget.id) {
        modifiedData[rootId]["parentId"] = dropTarget.id
      }
      const payload: any = {
        rootId,
        components: modifiedData,
        componentOrder: [rootId],
      }

      store.dispatch({
        type: PASTE_COPIED_ELEMENT,
        data : payload
      });
      
      myUndoStack.push(payload);
      myRedoStack.clear();
   
      store.dispatch(pushFormActionStack({
        undo: () => {
          const poppedElement = myUndoStack.pop();
          if (poppedElement) {
            myRedoStack.push(poppedElement);
            store.dispatch(
              removeElement({
                id: poppedElement.rootId,
                parentId: poppedElement.components[rootId]?.parentId,
                type: poppedElement.components[rootId]?.type,
                increment: -1
              }),
            )
          }
        },
        redo: () => {
          const poppedElement = myRedoStack.pop();
          if (poppedElement) {
            myUndoStack.push({ ...poppedElement });
            store.dispatch(pasteCopiedElemenet({
              rootId: poppedElement.rootId,
              componentOrder: poppedElement.componentOrder,
              components: poppedElement.components,
              increment: 1
            }));
          }
        }
      }));

    } catch (err) {
      logger.error(err);
    }
  }
  // if the item being dropped originates from the Sidebar
  if (droppedItem.type === ItemTypes.COMPONENT) {
    let defaultValues: any;
    const newItemId = getRandomId();
    if (isCoreV3) {
      defaultValues = getDefaultValuesv3(json.type, deviceType, dropTarget.id);
    } else {
      defaultValues = getDefaultValues(json.type, deviceType, dropTarget.id);
    }

    const data = {
      id: newItemId,
      fields: [],
      ...defaultValues,
      ...json,
    }

    if(dropTarget.id) {
      data.parentId = dropTarget.id
    }

    undoRedoOnAdd(data)

    store.dispatch({
      type: CREATE_FORM_JSON,
      data
    });

    // Draft: if dropped item is custom modal then show it and select it immediately,
    //
    // if (droppedItem.json.type === "CustomModal") {
    //   const dataCustomModal = {
    //     id: newItemId,
    //     isAssetInstanceSelected: false
    //   }
      
    //   store.dispatch({
    //     type: SET_MODAL_VISIBILITY,
    //     data: {
    //       visible: true,
    //       componentId: newItemId,
    //     }
    //   })

    //   store.dispatch({
    //     type: SELECTED_FORM_ID,
    //     data: dataCustomModal,
    //   })
    // }
    return newItemId;
  }


  // if the item types is formWizard
  if (droppedItem.type === ItemTypes.FORMWIZARD) {
    try {
      const formWizardValues = wizardContentInitialState(dropTarget.id);
      store.dispatch({
        type: SAVE_FORM_JSON,
        data : {
          components: formWizardValues.components,
          id: dropTarget.id !== '' ? '' : formWizardValues.id
        }
      });
      if(dropTarget.id !== '') {
        store.dispatch({
          type: UPDATE_PARENT_FIELDS,
          data : {
            parentId: dropTarget.id,
            id: formWizardValues.id
          }
        });
      }
      const payload: any = {
        rootId: formWizardValues.id,
        components: formWizardValues.components,
        componentOrder: [formWizardValues.id],
      }
      myUndoStack.push(payload);
      myRedoStack.clear();
  
      store.dispatch(pushFormActionStack({
        undo: () => {
          const poppedElement = myUndoStack.pop();
          if (poppedElement) {
            myRedoStack.push(poppedElement);
            store.dispatch(
              removeElement({
                id: poppedElement.rootId,
                parentId: poppedElement?.components[poppedElement.rootId]?.parentId,
                type: poppedElement?.components[poppedElement.rootId]?.type,
                increment: -1
              }),
            )
          }
        },
        redo: () => {
          const poppedElement = myRedoStack.pop();
          if (poppedElement) {
            myUndoStack.push({ ...poppedElement });
            store.dispatch(pasteCopiedElemenet({
              rootId: poppedElement.rootId,
              componentOrder: poppedElement.componentOrder,
              components: poppedElement.components,
              increment: 1
            }));
          }
        }
      }));
    } catch(err) {
      logger.error(err);
    }
  }

  // if the item being dropped comes from the FormDesigner
  if (droppedItem.type === ItemTypes.ELEMENT) {
    
    const payload: any = {
      id: json.id,
      dragSourceId: json.parentId,
      dropTargetId: dropTarget.id,
      index: json.index
     }
     
    if (json.parentId === dropTarget.id) {
      return
    }

    myUndoStack.push({ ...payload });
    store.dispatch(pushFormActionStack({
      undo: () => {
        const poppedElement = myUndoStack.pop();
        if (poppedElement) {
          myRedoStack.push(poppedElement);
          store.dispatch(transferUndoRedoElementReference({
            id: poppedElement.id,
            dragSourceId: poppedElement.dropTargetId,
            dropTargetId: poppedElement.dragSourceId,
            index: poppedElement.index,
            increment: -1
          }))
        }
      },
      redo: () => {
        const poppedElement = myRedoStack.pop();
        if (poppedElement) {
          myUndoStack.push({ ...poppedElement });
          store.dispatch(transferUndoRedoElementReference({
            id: poppedElement.id,
            dragSourceId: poppedElement.dragSourceId,
            dropTargetId: poppedElement.dropTargetId,
            increment: 1
          }))
        }
      }
    }));
    store.dispatch({
      type: TRANSFER_ELEMENT_REFERENCE,
      data: {
        id: json.id,
        dragSourceId: json.parentId,
        dropTargetId: dropTarget.id,
      },
    });
    return
  }

  // if the item gets dropped is an asset
  if (droppedItem.type === ItemTypes.ASSET) {
    const { assetId, type } = json
    const assetInstanceId = getRandomId()
    const assets = store.getState().formJson.assets
    const componentOrder = assets[assetId].json.componentOrder

    // if it's an empty asset, skip dropping
    if(!componentOrder.length) {
      return
    }

    const [rootId] = componentOrder
    const data: any = {
      assetId,
      id: assetInstanceId + "_" + rootId,
      assetInstanceId,
      assetBindPrefix: getRandomId(),
      isAsset: true,
      fields: [],
      type: type
    }

    if(dropTarget.id) {
      data.parentId = dropTarget.id
    }

    undoRedoOnAdd(data)

    store.dispatch({
      type: CREATE_FORM_JSON,
      data
    });
    const formJson = store.getState().formJson;
    addAssetInstancesToForm(formJson);
  }

};

function modifyJson(jsonObject: any, randomId: string) {
  function findIds(obj: any, ids: any = []) {
      for (let key in obj) {
          if (typeof obj[key] === "object" && obj[key] !== null) {
              findIds(obj[key], ids);
          } else if (key === "id") {
              ids.push(obj[key]);
          }
      }
      return ids;
  }

  let idsToChange = findIds(jsonObject);
  let inputString = JSON.stringify(jsonObject);
  function replaceSubstrings(
      idsToChange: any,
      randomId: string,
      inputString: any
  ) {
      idsToChange?.forEach((word: any) => {
          let regex = new RegExp(
            `(["' \\[{(]|\\.\\s*)${word}(\\\\?"|["' ,.\\]})])`,
            "g"
          );
          inputString = inputString.replace(regex, `$1${word + randomId}$2`);
      });
      return inputString;
  }

  let replaceString = replaceSubstrings(idsToChange, randomId, inputString);
  return JSON.parse(replaceString);
}
const undoRedoOnAdd = (data: any) => {
  myUndoStack.push({ ...data });
  myRedoStack.clear();

  store.dispatch(
    pushFormActionStack({
      undo: () => {
        const poppedElement = myUndoStack.pop();
        if (poppedElement) {
          myRedoStack.push(poppedElement);
          store.dispatch(
            undoDropElement({
              id: poppedElement.id,
              parentId: poppedElement.parentId,
              type: data.type,
              increment: -1,
            })
          );
        }
      },
      redo: () => {
        const poppedElement = myRedoStack.pop();
        if (poppedElement) {
          myUndoStack.push({ ...poppedElement });
          store.dispatch(
            redoComponentDropToFormJson({ ...poppedElement, increment: 1 })
          );
        }
      },
    })
  );
};
